<template>
    <div class="the-navbar__user-meta flex items-center" v-if="$store.getters.userData">

        <div class="text-right leading-tight hidden sm:block">
            <p class="font-semibold">{{ $store.getters.userData.name + " " + $store.getters.userData.l_name }}</p>
            <small>-</small>
        </div>

        <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">

            <div class="con-img ml-3">
                <img src="@/assets/images/portrait/small/empty-profile-picture.png" alt="user-img" width="40" height="40" class="rounded-full shadow-md cursor-pointer block" />
            </div>

            <vs-dropdown-menu class="vx-navbar-dropdown">
                <ul style="min-width: 13rem">

                    <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="changePassPrompt = true">
                        <feather-icon icon="LockIcon" svgClasses="w-4 h-4" />
                        <span class="ml-2">Change password</span>
                    </li>

                    <vs-divider class="m-1" />

                    <li
                        class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                        @click="logout">
                        <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
                        <span class="ml-2">Logout</span>
                    </li>
                </ul>
            </vs-dropdown-menu>
        </vs-dropdown>

        <vs-popup title="Change password" :active.sync="changePassPrompt">
            <div id="changePassDiv">
                <p class="mt-6">Current password</p>
                <vs-input type="password" v-model="oldPass" style="width: 100%"></vs-input>
                <p class="mt-6">New password</p>
                <vs-input type="password" v-model="newPass" style="width: 100%"></vs-input>
                <p class="mt-6">Repeat new password</p>
                <vs-input type="password" v-model="newPassRepeat" style="width: 100%"></vs-input>
                <vs-divider/>
                <vs-button :disabled="newPass !== newPassRepeat || newPass.length === 0 || oldPass.length === 0" style="float: left" color="success" icon-pack="feather" icon="icon-edit" class="mt-6; mr-1" @click="changePass">Change password</vs-button>
            </div>
        </vs-popup>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                changePassPrompt: false,
                oldPass: '',
                newPass: '',
                newPassRepeat: ''
            }
        },
        computed: {
            activeUserInfo() {
                return this.$store.state.AppActiveUser
            }
        },
        methods: {
            logout() {
                const thisIns = this
                thisIns.$store.dispatch('setLoginStatus', false)
                this.$http.get('/api/management/v1/logout/')
                    .then(function() {
                        thisIns.$router.push('/login')
                    }).catch(function(error) {
                        thisIns.$printError(error.response.data)
                    })
            },
            changePass() {
                this.$vs.loading()
                const thisIns = this
                this.$http.put('/api/management/v1/profile/password', {
                    old_pass: this.oldPass,
                    new_pass: this.newPass
                }).then(function() {
                    thisIns.changePassPrompt = false
                    thisIns.oldPass = ''
                    thisIns.newPass = ''
                    thisIns.newPassRepeat = ''
                    thisIns.$printSuccess('Password changed!')
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close()
                })
            }
        }
    }
</script>
